// acessos-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Acesso revogado": "Acceso revocado",
    "Acessos conectados": "Accesos conectados",
    "Ativas": "Activas",
    "Cadastrada em %{arg1}": "Registrada en %{arg1}",
    "Com IP diferente do cadastro": "Con IP distinta a la del registro",
    "Com mais de um dispositivo": "Con más de un dispositivo",
    "Expirada": "Expirada",
    "Funcionários com acesso": "Empleados con acceso",
    "IP atual": "IP actual",
    "Nenhum acesso ativo com esses filtros.": "Ningún acceso activo con esos filtros.",
    "Nenhuma sessão encontrada com esses filtros.": "Ninguna sesión encontrada con esos filtros.",
    "Nome, login ou IP": "Nombre, usuario o IP",
    "Não foi possível revogar o acesso": "No fue posible revocar el acceso",
    "O acesso deste dispositivo de %{quem} será encerrado.": "El acceso de este dispositivo de %{quem} será finalizado.",
    "Ociosas há mais de 7 dias": "Inactivas hace más de 7 días",
    "Relatório de acessos conectados": "Informe de accesos conectados",
    "Revogada": "Revocada",
    "Revogadas": "Revocadas",
    "Revogar": "Revocar",
    "Revogar acesso": "Revocar acceso",
    "Revogar encerra o acesso daquele navegador na próxima renovação do token — no máximo 30 minutos. Para cortar na hora em caso de máquina comprometida, revogue todos os acessos do funcionário e peça a troca da senha.": "Revocar finaliza el acceso de ese navegador en la próxima renovación del token — como máximo 30 minutos. Para cortar de inmediato en caso de equipo comprometido, revoque todos los accesos del empleado y solicite el cambio de contraseña.",
    "Revogar todos": "Revocar todos",
    "Sessões ativas": "Sesiones activas",
    "Todos os acessos de %{quem} serão encerrados e a pessoa precisará entrar de novo em cada dispositivo.": "Todos los accesos de %{quem} serán finalizados y la persona deberá iniciar sesión nuevamente en cada dispositivo.",
    "Todos os acessos do funcionário foram revogados": "Todos los accesos del empleado fueron revocados",
    "ociosa há %{arg1} dias": "inactiva hace %{arg1} días",
};

export default catalogo;
